/* src/app/components/discovery/dialogs/create-production-job-dialog/create-production-job-dialog.component.scss */
.actions-container {
  align-items: baseline;
  display: flex;
  justify-content: flex-end;
}
/*# sourceMappingURL=create-production-job-dialog.component.css.map */
